import AsyncPage from './AsyncPage';

export default AsyncPage;
